import { css } from "@stubhub/broadway-foundation/css";

export const popupContainer = css({
  position: "fixed",
  insetBlockEnd: "primitives.300",
  insetInlineEnd: "primitives.300",
  zIndex: "[100]",
  width: "[420px]",
  maxWidth: "[calc(100vw - var(--bway-spacing-primitives-400))]",
  backgroundColor: "bg.surface",
  borderStartStartRadius: "element.default",
  borderStartEndRadius: "element.default",
  borderEndStartRadius: "element.default",
  borderEndEndRadius: "element.default",
  borderBlockStartWidth: "[1px]",
  borderBlockEndWidth: "[1px]",
  borderInlineStartWidth: "[1px]",
  borderInlineEndWidth: "[1px]",
  borderBlockStartStyle: "[solid]",
  borderBlockEndStyle: "[solid]",
  borderInlineStartStyle: "[solid]",
  borderInlineEndStyle: "[solid]",
  borderBlockStartColor: "border.subtle",
  borderBlockEndColor: "border.subtle",
  borderInlineStartColor: "border.subtle",
  borderInlineEndColor: "border.subtle",
  boxShadow: "[0 8px 24px rgba(0, 0, 0, 0.12)]",
  paddingBlockStart: "primitives.250",
  paddingBlockEnd: "primitives.200",
  paddingInlineStart: "primitives.250",
  paddingInlineEnd: "primitives.250",
  display: "flex",
  flexDirection: "column",
  rowGap: "primitives.150",
  columnGap: "primitives.150",
});

export const popupHeader = css({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  rowGap: "primitives.150",
  columnGap: "primitives.150",
});

export const popupTitle = css({
  flexGrow: "1",
  flexShrink: "1",
  flexBasis: "[0%]",
  textStyle: "header.small",
});

export const popupSubtitle = css({
  textStyle: "body.medium",
  color: "text.subtle",
});

export const popupContentArea = css({
  // Override the inner ContentViewContainer's (styled-components, unlayered) padding so
  // input/button/privacy text align flush with the popup's own title and subtitle.
  // PandaCSS styles are layered and cannot beat unlayered styles without !important.
  "& > div": {
    // eslint-disable-next-line panda/no-important, panda/prefer-atomic-properties -- PandaCSS (layered) cannot override styled-components (unlayered) without !important
    padding: "[0 !important]",
  },
});

export const popupCloseButton = css({
  outlineWidth: "[0]",
  outlineStyle: "[none]",
  backgroundColor: "[transparent]",
  borderBlockStartWidth: "primitives.0",
  borderBlockEndWidth: "primitives.0",
  borderInlineStartWidth: "primitives.0",
  borderInlineEndWidth: "primitives.0",
  cursor: "pointer",
  paddingBlockStart: "primitives.25",
  paddingBlockEnd: "primitives.25",
  paddingInlineStart: "primitives.25",
  paddingInlineEnd: "primitives.25",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  color: "text.subtle",
  lineHeight: "[1]",
  _focusVisible: {
    outlineWidth: "[2px]",
    outlineStyle: "[solid]",
    outlineColor: "border.brand",
    outlineOffset: "[2px]",
  },
});
